import { motion } from 'framer-motion';
import { Shield, Award, CheckCircle, BadgeCheck, ExternalLink, Building2 } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';

const TrustLogos = () => {
  const { t } = useI18n();

  const trustItems = [
    { icon: Shield, label: t.trust.dataProtected, sublabel: t.trust.dataProtectedSub },
    { icon: Award, label: t.trust.registered, sublabel: t.trust.registeredSub },
    { icon: CheckCircle, label: t.trust.realOffice, sublabel: t.trust.realOfficeSub },
    { icon: BadgeCheck, label: t.trust.experience, sublabel: t.trust.experienceSub },
  ];

  const verifiedCompanies = [
    { name: 'Punto Hispano Gestoría GmbH', url: 'https://www.moneyhouse.ch/de/company/punto-hispano-gestoria-gmbh-12392439941' },
    { name: 'Punto Hispano Immobilien GmbH', url: 'https://www.moneyhouse.ch/de/company/punto-hispano-immobilien-gmbh-3808937711' },
    { name: 'Punto Hispano Holding GmbH', url: 'https://www.moneyhouse.ch/de/company/punto-hispano-holding-gmbh-15725096541' },
    { name: 'Punto Hispano Seguros y Pensiones GmbH', url: 'https://www.moneyhouse.ch/de/company/punto-hispano-seguros-y-pensiones-gmbh-12949431471' },
  ];

  return (
    <section className="relative py-8 md:py-10 bg-gray-100 dark:bg-cinema-surface border-y border-gray-200 dark:border-white/5 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-punto/5 via-transparent to-punto/5" />
      <div className="container mx-auto px-4 relative z-10">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-4">
          <p className="text-gray-500 dark:text-white/40 text-xs md:text-sm uppercase tracking-widest mb-3">
            {t.trust.headline}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4">
            <span className="text-[10px] md:text-xs text-gray-400 dark:text-white/30 flex items-center gap-1">
              <Building2 className="w-3 h-3" />
              {t.trust.verifiedLabel}
            </span>
            {verifiedCompanies.map((company, index) => (
              <a key={index} href={company.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[10px] md:text-xs text-punto hover:text-punto/80 transition-colors hover:underline">
                {company.name}
                <ExternalLink className="w-2.5 h-2.5" />
              </a>
            ))}
          </div>
        </motion.div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6 max-w-4xl mx-auto px-2">
          {trustItems.map((item, index) => (
            <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.1 }} className="flex items-center gap-2 md:gap-3 px-2 md:px-3 py-2 md:py-2.5 rounded-lg bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 hover:border-punto/30 transition-all group shadow-sm">
              <div className="p-1.5 md:p-2 rounded-md bg-punto/10 group-hover:bg-punto/20 transition-colors shrink-0">
                <item.icon className="w-4 h-4 text-punto" />
              </div>
              <div className="text-left min-w-0">
                <div className="text-gray-900 dark:text-white text-xs md:text-sm font-medium">{item.label}</div>
                <div className="text-gray-400 dark:text-white/40 text-[10px] md:text-xs">{item.sublabel}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustLogos;
